<cm-three-template-scene-provider (onInitialized)="onInititalizedThreeSceneManagerService($event)">
    <h1>Backend AR generation</h1>
</cm-three-template-scene-provider>
